export const swobbeeColor = "#FF5A00";
export const enyringColor = "#0468bf";
